import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@elotech/angular-common';
import { ExportReportService } from '../../../../folha-pagamento/src/export-report/export-report.service';
import { ReportParams } from '../../../../folha-pagamento/src/export-report/report-params';
import { ReportProgress } from '../../../../folha-pagamento/src/common/interface/report-progress';

@Injectable()
export class PortalExportReportService extends ExportReportService {

  private readonly resourcePortal: string = '/api/portal-servidor/report';

  constructor(httpClient: HttpClient) {
    super(httpClient);
  }

  public executeAsyncReport(params: ReportParams[], idRelatorio: string): Observable<ReportProgress> {
    return this.httpClient.post({
      resource: `${this.resourcePortal}/${idRelatorio}`,
      body: params,
      disableSpinner: true
    });
  }
}
